import { render, staticRenderFns } from "./AiSuggestionCompetitorParser.vue?vue&type=template&id=04eafad7"
import script from "./AiSuggestionCompetitorParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionCompetitorParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports